// extracted by mini-css-extract-plugin
module.exports = {"rules":"styles_rules__1-0Ac","more":"styles_more__26WWV"};